import { IPromise } from 'angular';

import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import { DeleteDataSourceVersionsRequest } from '../ServerApi/requests/DeleteDataSourceVersionsRequest';
import {
  GetDatasourceVersionsRequest,
  IGetDatasourceVersionsResult,
} from '../ServerApi/requests/getDatasourceVersionsRequest';
import { IDataSourceRevision } from '../ServerApi/types/IContentRevision';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { Resource } from './Resource';

export class DatasourceRevisions extends Resource<IDataSourceRevision>  {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  private server: ServerService;

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetDatasourceVersionsRequest,
      (result: IGetDatasourceVersionsResult) => result.versions));

    this.server = ErrorNotifyingServer.getServerService();
  }

  public del = (id: string): IPromise<IResult> => {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteDataSourceVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

}

Module.instance().service('DatasourceRevisions', DatasourceRevisions);
